/* eslint-disable no-unused-vars */
export enum LocalStorageKeyEnum {
    CONFIG = 'config',
    DISMISSED_ANNOUNCEMENTS = 'dismissedAnnouncements',
    CURRENT_CUSTOMER_CODE = 'currentCustomerCode',
    CURRENT_PHARMACY_CODE = 'currentPharmacyCode',
    ID_TOKEN = 'id_token',
    OAUTH2_TOKEN = 'oauth2_token',
    TOKEN_EXPIRATION = 'tokenExpiration',
    USER_MODE_CUSTOMER_CODES = 'userModeCustomerCodes',
}
